<template>
  <div class="louFeng-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入用户Id" v-model.number="searchParams.uid" clearable size="small" class="param-input">
      </el-input>
      <el-input placeholder="请输入标题" v-model.number="searchParams.title" clearable size="small" class="param-input">
      </el-input>
      <el-select placeholder="是否激活" v-model="searchParams.isUse" size="small" clearable style="width:200px;margin-right:5px">
        <el-option :value="true" label="已激活" key="已激活"></el-option>
        <el-option :value="false" label="未激活" key="未激活"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getNakedChatList('status')" style="margin-right: 20px">搜索
      </el-button>
      <el-button type="primary" size="small" @click="add()" class="add-input" style="margin-right: 20px">+新增</el-button>
      <el-button type="success" size="small" @click="announcement()" class="add-input">官方公告</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" ref="multipleTable" height="550"
              @sort-change="handleSortChange">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="imageCover" label="图片封面" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="!scope.row.imageCover || !scope.row.imageCover.length">未知</span>
          <div v-else class="picturePreview">
            <img-load style="width: 50px; height: 80px" :src="imgUrl + item" fit="fill"
                      v-for="(item, i) in scope.row.imageCover" :key="i"></img-load>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="videoCover" label="视频" align="center" width="200">
        <template slot-scope="scope">
          <span v-if="!scope.row.videoCover || !scope.row.videoCover.length">-</span>
          <div v-else class="picturePreview" @click="previewPicture(scope.row.videoCover, scope.row.id)">
            <img-load style="width: 50px; height: 80px" :src="imgUrl + item" fit="fill"
                      v-for="(item, i) in scope.row.videoCover" :key="i"></img-load>
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="url" label="视频预览" align="center" width="100">
        <template slot-scope="scope">
          <i
            class="el-icon-video-play views"
            title="点击预览"
            @click="checkMedia(scope.row.videoCover[0], 'video')"
            v-if="scope.row.videoCover && scope.row.videoCover.length > 0"
          ></i>
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.age || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="height" label="身高" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.height || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="体重" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.weight || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cup" label="罩杯" align="center" min-width="100">
        <template slot-scope="scope">
          <el-tag type="danger">{{ cupParse(scope.row.cup) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系方式" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.contact }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceItems" label="服务项目" align="center" min-width="200">
        <template slot-scope="scope">
          <el-row>
            <el-col v-for="id in scope.row.serviceItems" :key="id">
              <el-tag type="success">{{ serviceItemParse(id) }}
              </el-tag>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column prop="serviceTime" label="连线时间" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="detail" label="详情介绍" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.detail }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="countPurchases" label="购买数量" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.countPurchases }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fakePurchasesCount" label="假购买数量" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.fakePurchasesCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isActive" label="是否激活" align="center" min-width="120">
        <template slot-scope="scope">
          <el-tag :type="(scope.row.isActive ? 'success' : '')">{{ scope.row.isActive ? '激活' : '未激活' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="120">
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="280">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="editChat(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="searchParams.pageNumber" :page-size="searchParams.pageSize"
                   layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10"
                   @size-change="changeSize" @current-change="changeCurrent"></el-pagination>

    <el-dialog :title="isAdd ? '新增裸聊' : '修改裸聊'" :visible.sync="dialogVisible" width="480px" height=100%
               :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="90px" label-position="right">
        <div class="form-flex-box">
          <el-form-item label="图片封面:" prop="cover">
            <imgs-upload
                :cover="params.imageCover"
                :action="action"
                @successCallback="successImageCover"
                :notLimit="true"
                :wSize="180"
                :hSize="320"
                :width="'100px'"
                :height="'100px'"
                ref="imgUpload"
            ></imgs-upload>
          </el-form-item>
        </div>
        <div class="flex-item">
          <el-form-item label="上传视频:">
            <!--视频分片上传-->
            <uploader
              :options="options"
              class="uploader-example"
              ref="uploader"
              @file-added="fileAdd"
              @file-success="onFileSuccess"
            >
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :attrs="attrs">上传视频</uploader-btn>
              </uploader-drop>
              <uploader-list style="width: 350px"></uploader-list>
              <!-- <uploader-list v-show="panelShow">
                <div class="file-panel" slot-scope="props" :class="{ collapse: collapse }">
                  <div class="file-title">
                  <h2>文件列表</h2>
                  <div class="operate">
                    <el-button
                      @click="fileListShow"
                      type="text"
                      :title="collapse ? '展开' : '折叠'">
                      <i class="iconfont" :class="collapse ? 'inuc-fullscreen' :  'inuc-minus-round'" ></i>
                    </el-button>
                    <el-button @click="close" type="text" title="关闭">
                      <i class="iconfont icon-close"></i>
                    </el-button>
                  </div>
                </div>
  
                <ul class="file-list" ref="fList">
                  <li v-for="file in props.fileList" :key="file.id">
                    <uploader-file
                      :class="'file_' + file.id"
                      ref="files"
                      :file="file"
                      :list="true"
                    ></uploader-file>
                  </li>
                  <div class="no-file" v-if="!props.fileList.length">
                    <i class="iconfont icon-empty-file"></i> 暂无待上传文件
                  </div>
                </ul>
              </div>
              </uploader-list> -->
            </uploader>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标题:" prop="title">
            <el-input v-model.trim="params.title" size="small"></el-input>
          </el-form-item>
          <el-form-item label="连线时间:" prop="serviceTime">
            <el-input v-model.trim="params.serviceTime" size="small"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="联系方式:" prop="contact">
          <el-input type="textarea" :rows="3" v-model="params.contact" size="small"></el-input>
        </el-form-item>
        <div class="form-flex-box">
          <el-form-item label="用户ID:" prop="uid">
            <el-input v-model.number="params.uid" size="small"></el-input>
          </el-form-item>
          <el-form-item label="排序:" prop="sort">
            <el-input v-model.number="params.sort" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="年龄:" prop="age">
            <el-input v-model.number="params.age" size="small"></el-input>
          </el-form-item>
          <el-form-item label="身高:" prop="height">
            <el-input v-model.number="params.height" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="体重:" prop="weight">
            <el-input v-model.number="params.weight" size="small"></el-input>
          </el-form-item>
          <el-form-item label="罩杯:" prop="cup">
            <el-select v-model="params.cup" placeholder="请选择罩杯" size="small">
              <el-option v-for="item in cupSelect" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="假购买数量:" prop="fakePurchasesCount">
            <el-input v-model.number="params.fakePurchasesCount" size="small"></el-input>
          </el-form-item>
          <el-form-item label="" prop=""></el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tags">
            <tag-selector
              v-model="params.tags"
              :tagList="[]"
            ></tag-selector>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="服务项目:" prop="serviceItems">
            <el-checkbox-group v-model="params.serviceItems" :max="3">
              <el-checkbox v-for="product in this.productCheckbox" :label="product.id" :key="product.id">
                {{ product.productName }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="详情介绍:" prop="detail">
            <el-input type="textarea" :rows="3" v-model="params.detail" size="small"></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="是否激活:" prop="isActive">
            <el-switch v-model="params.isActive"></el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleClose()">取 消</el-button>
        <el-button type="primary" size="small" @click="submitDate()">确 认</el-button>
      </div>
    </el-dialog>
    <!--官方公告-->
    <el-dialog :title="'裸聊官方公告'" :visible.sync="isAnnouncement" width="480px" height=100%
               :before-close="handleAnnouncementClose" :close-on-click-modal="false">
      <el-form ref="form" :model="config" label-width="90px" label-position="right">
        <el-form-item label="内容:" prop="contact">
          <el-input v-model.trim="config.content" size="small" type="textarea"></el-input>
        </el-form-item>
        <div class="form-flex-box">
          <el-form-item label="是否激活:" prop="isActive">
            <el-switch v-model="config.isActive"></el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleAnnouncementClose()">取 消</el-button>
        <el-button type="primary" size="small" @click="editAnnouncement()">确 认</el-button>
      </div>
    </el-dialog>
    <!--封面图、视频弹窗组件-->
    <media-popup ref="mediaPopup"></media-popup>
  </div>
</template>

<script>
import API from "@/api";
import MediaPopup from "@/components/media-popup";
import baseConfig from "@/utils/serverUrlConfig";
import {sortEscape} from "@/utils/global";
import local from "@/utils/localStroage.js";
import TagSelector from "@/components/tagSelector";
export default {
  data() {
    return {
      action: baseConfig.baseServerUrl + '/vid/uploadStaticBatch',
      imgUrl: baseConfig.imgUrl,
      // 表格数据加载动画
      loading: false,
      // 商品复选框
      productCheckbox: [],
      // 列表数据
      tableData: [],
      total: 0,
      // 罩杯数据
      cupSelect: [
        {label: "C", value: 1},
        {label: "D", value: 2},
        {label: "E", value: 3},
        {label: "F", value: 4},
      ],
      attrs: {
        accept: [
          ".mp4",
          ".qlv",
          ".qsv",
          ".ogg",
          ".flv",
          ".avi",
          ".wmv",
          ".rmvb",
        ], //接受文件类型
      },
      // 系统管理列表请求参数
      searchParams: {
        pageNumber: 1,
        pageSize: 10,
      },
      params: {
        uid: '',
        id: undefined,
        imageCover: [],
        videoCover: [],
        age: '',
        height: '',
        weight: '',
        cup: '',
        tags: [],
        contact: "",
        serviceItems: [],
        serviceTime: "",
        detail: "",
        title: "",
        isActive: '',
        sort: "",
        fakePurchasesCount: '',
      },
      // 官方公告
      config: {
        id: '',
        content: '',
        isActive: undefined,
      },
      dialogVisible: false,
      isAdd: true,
      isAnnouncement: false,
      rules: {
        title: [{required: true, message: '必填', trigger: 'blur'}],
        age: [{required: true, message: '必填', trigger: 'blur'}],
        height: [{required: true, message: '必填', trigger: 'blur'}],
        cup: [{required: true, message: '必填', trigger: 'blur'}],
        uid: [{required: true, message: '必填', trigger: 'blur'}],
      },
    };
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + "/vid/uploadDotStream", //上传地址
        testChunks: false, //是否开启服务器分片校验
        method: "application/json",
        headers: {
          // 额外请求头
          Authorization: local.get("userInfo")
            ? local.get("userInfo").token
            : "",
        },
        fileParameterName: "upload", //文件名参数，默认为file
        query: this.uploadQuery, //额外参数
        singleFile: true, //单文件上传
        chunkSize: 2048000, //分片大小，默认1M
        simultaneousUploads: 6,
        // 把英文时间转成中文
        parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, "年")
            .replace(/\days?/, "天")
            .replace(/\shours?/, "小时")
            .replace(/\sminutes?/, "分钟")
            .replace(/\sseconds?/, "秒");
        },
      };
    },
  },
  components: { MediaPopup, TagSelector },
  created() {
    this.getNakedChatList();
    this.getProductCheckbox();
  },
  methods: {
    cupParse(cup) {
      let name = '';
      this.cupSelect.forEach(e => {
        if (cup === e.value) {
          name = e.label;
        }
      })
      return name
    },
    serviceItemParse(id) {
      let name = '';
      this.productCheckbox.forEach(e => {
        if (id === e.id) {
          name = e.productName
        }
      })
      return name
    },
    getProductCheckbox() {
      API.getProductCheckbox({"productType": 12})
          .then((res) => {
            if (res.code === 200 && res.data) {
              this.productCheckbox = res.data.data;
            } else {
              this.productCheckbox = [];
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    // 请求楼凤信息列表
    getNakedChatList(type) {
      this.loading = true;
      if (type === "status") {
        this.searchParams.pageNumber = 1;
      }
      API.getNakedChatList(this.searchParams)
          .then((res) => {
            if (res.code === 200 && res.data) {
              this.tableData = res.data.data;
              this.total = res.data.total;
            } else {
              this.tableData = [];
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    //视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: String(this.trackId),
        // totalPos:chunk.offset+1,
        // data:data
      };
    },
    //视频上传选中时
    fileAdd() {
      this.generateTaskId();
    },
    //定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime();
      this.trackId = time;
    },
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      this.params.videoCover = [];
      let res = JSON.parse(response);
      this.params.videoCover.push(res.data.sourceURL);
    },

    // 查看媒体
    checkMedia(url, type) {
      this.$refs.mediaPopup.open(url, type);
    },
    // 删除
    remove(id) {
      this.$confirm("您确定要删除当前信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            API.deleteLoufeng({id: id}).then((res) => {
              if (res.code === 200) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                this.getNakedChatList();
              } else {
                this.$message.error("删除失败");
              }
            });
          })
          .catch(() => {
          });
    },
    // 关闭弹窗
    handleClose() {
      this.params.id = undefined;
      this.params.imageCover = [];
      this.params.videoCover = [];
      this.dialogVisible = false;
      this.$refs['form'].resetFields();
      this.$refs.imgUpload.clearImg();
      // this.$refs.videoCoverUpload.clearImg();
      this.params.uid = '';
      this.params.age = '';
      this.params.height = '';
      this.params.weight = '';
      this.params.cup = '';
      this.params.tags = [];
      this.params.contact = '';
      this.params.serviceItems = [];
      this.params.serviceTime = '';
      this.params.detail = '';
      this.params.title = '';
      this.params.isActive = '';
      this.params.sort = '';
      this.params.fakePurchasesCount = '';
      this.getNakedChatList();
    },
    // 关闭弹窗
    handleAnnouncementClose() {
      this.params.id = undefined;
      this.isAnnouncement = false;
    },
    // 数据排序
    handleSortChange(column) {
      this.params.value = sortEscape(column.order);
      this.params.key = column.prop;
      this.getNakedChatList();
    },
    // 封面图上传成功回调
    successImageCover(cover) {
      this.params.imageCover = cover;
    },
    // 封面图上传成功回调
    successVideoCover(cover) {
      this.params.videoCover = cover;
    },
    // 新增
    add() {
      this.dialogVisible = true;
      this.isAdd = true;
    },
    // 官方公告
    announcement() {
      // 查询公告内容
      API.nakedChatConfig({})
          .then((res) => {
            if (res.code === 200 && res.data) {
              this.config.id = res.data.id
              this.config.content = res.data.content
              this.config.isActive = res.data.isActive
            } else {
              this.tableData = [];
            }
          })
          .catch(() => {
          });
      this.isAnnouncement = true;
    },

    // 官方公告修改
    editAnnouncement() {
      API.updateNakedChatConfig(this.config).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
        } else {
          this.$message.error('操作失败！');
        }
        this.handleAnnouncementClose()
      }).catch(() => {
        this.handleAnnouncementClose()
      })
    },

    // 修改
    editChat(row) {
      this.params.id = row.id;
      this.params.uid = row.uid;
      this.params.imageCover = row.imageCover;
      this.params.videoCover = row.videoCover;
      this.params.age = row.age;
      this.params.height = row.height;
      this.params.weight = row.weight;
      this.params.cup = row.cup;
      this.params.tags = row.tags;
      this.params.contact = row.contact;
      this.params.serviceItems = row.serviceItems;
      this.params.serviceTime = row.serviceTime;
      this.params.detail = row.detail;
      this.params.title = row.title;
      this.params.isActive = row.isActive;
      this.params.sort = row.sort;
      this.params.fakePurchasesCount = row.fakePurchasesCount;
      this.isAdd = false;
      this.isAnnouncement = false;
      this.dialogVisible = true;
    //   window.console.log(row.imageCover)
      setTimeout(() => {
        this.$refs.imgUpload.getFileList(row.imageCover);
        // this.$refs.videoCoverUpload.getFileList(row.videoCover);
      }, 100)
    },

    // 确认提交
    submitDate() {
      if (this.params.serviceItems.length === 0) {
        this.$message({
          message: '服务项目至少选择一项',
          type: 'error'
        });
        return;
      }
      
      if (this.isAdd) {
        API.addNakedChat(this.params).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
          } else {
            this.$message.error('操作失败！');
          }
          this.handleClose()
        }).catch(() => {
          this.handleClose()
        })
      } else {
        API.updateNakedChat(this.params).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '操作成功！',
              type: 'success'
            });
          } else {
            this.$message.error('操作失败！');
          }
          this.handleClose()
        }).catch(() => {
          this.handleClose()
        })
      }
    },
    //  图集预览
    previewPicture(pictureArr, id) {
      const Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id);
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.searchParams.pageSize = size;
      this.getNakedChatList();
    },
    // 分页页码改变回掉
    changeCurrent(pageNumber) {
      this.searchParams.pageNumber = pageNumber;
      this.getNakedChatList();
    },
    // 置顶操作
    upmost(data) {
      this.$refs.upmost.open(data);
    },
    // 取消置顶
    cancelTop(id) {
      API.cancelToplf({id: id}).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "取消置顶操作成功！",
            type: "success",
          });
          this.getNakedChatList();
        } else {
          this.$message.error("取消置顶操作失败！");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.payMethod {
  .add-input {
    margin-left: 0 !important;
  }
}
</style>
